

































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetCenter } from "@/request/idr";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../components/left-nav.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
  },
})
export default class CustomFolder extends Vue {
  private get user() {
    return this.$store.state.user;
  }
  //   /**
  //    * @description 初始化
  //    */
  //   private mounted() {
  //     console.log("this");
  //     console.log(this);
  //   }
  private goToResult(item) {
    this.$router.push({
      path: "/main/dig/custom-analysis",
      query: {
        type: item,
      },
    });
  }
}
